module.exports = __webpack_public_path__ + "static/img/book19.eeedcb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book19.jpg
// module id = +Rn1
// module chunks = 1